import type { UrqlOperationContext } from 'lib/urqlClient';
import assert from 'assert';
import React from 'react';
import { usePodApiAccessTokenContext } from 'wrappers/PodApiAccessTokenProvider';

import { useFlagEnabledWithOverrides } from './useFlagEnabledWithOverrides';
import { useWorkspace } from './useWorkspace';

export function useCustomerApiContext() {
  const { workspace } = useWorkspace();
  const podApiAccessTokens = usePodApiAccessTokenContext();
  const useTotalBalanceUpdates = useFlagEnabledWithOverrides(
    'dashboard-total-balance-enabled'
  );

  assert(workspace, 'Workspace pod info not found');
  const url = workspace.pod.dashboardCustomerApiUrl;

  const context: UrqlOperationContext = React.useMemo(
    () => ({
      token: podApiAccessTokens.customerApiToken,
      url,
      workspaceId: workspace.id,
      useTotalBalanceUpdates,
    }),
    [
      podApiAccessTokens.customerApiToken,
      url,
      workspace.id,
      useTotalBalanceUpdates,
    ]
  );

  return {
    context,
    token: podApiAccessTokens.customerApiToken,
  };
}
